import { request as uploadBannerImage } from '../../../modules/banners/actions/upload-banner-image';
import { error, finish } from '../../../modules/banners/actions/add-new-banner';
import api from '../../../api';
import {request as updateOrder} from '../../../modules/banners/actions/change-promotion-order';

export function request(dispatch, { body }) {
    api.post('/banners/create', body.data)
        .then(res => {
            dispatch(finish(res));
            dispatch(uploadBannerImage({
                file: body.file,
                bannerId: res['id']
            }));
            dispatch(updateOrder([
                {
                    id: res.id,
                    displayOrder: body.bannerOrder
                }
            ]));
        }).catch(err => {
            dispatch(error(err));
        });
}
